export * from './post-berichts-vorlage.component';
export * from './post-berichts-vorlage.component.module';